/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * does the product represent a one-time purchase or a subscription
 * @export
 */
export const ProductType = {
    Single: 'SINGLE',
    Subscription: 'SUBSCRIPTION'
} as const;
export type ProductType = typeof ProductType[keyof typeof ProductType];


export function ProductTypeFromJSON(json: any): ProductType {
    return ProductTypeFromJSONTyped(json, false);
}

export function ProductTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductType {
    return json as ProductType;
}

export function ProductTypeToJSON(value?: ProductType | null): any {
    return value as any;
}

